import { render } from "./NuovoRapportinoAppuntamento.vue?vue&type=template&id=28effd24&scoped=true"
import script from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"
export * from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"

import "./NuovoRapportinoAppuntamento.vue?vue&type=style&index=0&id=28effd24&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28effd24"]])

export default __exports__